export const SEEK_VIDEO_EVENT = "sheai:seek-video";

export interface VideoSeekDetail {
  seconds: number;
  sourceId?: string;
}

export function cameraLabel(sourceId?: string): string {
  if (sourceId === "camera1") return "Câmera 1 · Principal";
  if (sourceId === "camera2") return "Câmera 2 · Focal";
  const camera = sourceId?.match(/^camera([1-9]\d*)$/);
  if (camera) return `Câmera ${camera[1]}`;
  return sourceId ? `Fonte ${sourceId.replace(/[^\w-]/g, "").slice(0, 40)}` : "Vídeo";
}

/** Resolve apenas URLs de mídia; preserva o escape de caminhos já codificados. */
export function sourceVideoURL(uri?: string | null, generation?: string): string | undefined {
  if (!uri) return undefined;
  if (uri.startsWith("gs://")) {
    const match = uri.match(/^gs:\/\/([a-zA-Z0-9._-]+)\/(.+)$/);
    if (!match) return undefined;
    const path = match[2].split("/").map((part) => {
      try { return encodeURIComponent(decodeURIComponent(part)); }
      catch { return encodeURIComponent(part); }
    }).join("/");
    return `https://storage.googleapis.com/${match[1]}/${path}${generation ? `?generation=${encodeURIComponent(generation)}` : ""}`;
  }
  try {
    const url = new URL(uri);
    return ["http:", "https:"].includes(url.protocol) ? url.href : undefined;
  } catch { return undefined; }
}
